import { downloadBffFile } from "../../../common/download/downloadBffFile";
import { sanitizeFilename } from "../../../common/utils/sanitizeUtils";

export const downloadSeQaReport = ({ eventId, fileName }: { eventId: string; fileName: string }) =>
  downloadBffFile(`/api/buyer/events/${eventId}/qa-report`, sanitizeFilename(`${fileName}.pdf`));
